import { api } from './base';
import { Department } from './department.api';

export const departmentAdminApis = {
  getTree(parentId?: number): Promise<Array<Department>> {
    let url = '/admin/departments/tree';
    if (parentId) {
      url += `?parent_id=${parentId}`;
    }
    return api.get(url).then(r => r.departments);
  },
  save(department: Department): Promise<Department> {
    if (department.id) {
      return api.put(`/admin/departments/${department.id}`, department).then(r => r.department);
    } else {
      return api.post(`/admin/departments`, department).then(r => r.department);
    }
  },
  delete(departmentId: number) {
    return api.delete<void>(`/admin/departments/${departmentId}`);
  }
};
